<template>
  <div class="ws-members__search ws-search-experts">
    <b-field
      class="ws-field"
      :label="$t('Поиск')"
    >
      <ws-refbook-field
        v-bind="$attrs"
        entity="esatk/users"
        field="fullName"
        v-model="expertSearch.value"
        :guid.sync="expertSearch.guid"
        :item.sync="expertSearch.item"
        :custom-formatter="formatUserFullName"
        :placeholder="$t('Введите ФИО или электронную почту пользователя')"
        :is-clearable="false"
        :disabled="disabled"
        :query="{mode: 'ext/profile/contacts'}"
        :clear-on-select="true"
        :is-filter-selected="true"
        :isFocus="true"
        @change="onChange"
        :selected="selected"
      >
        <template slot-scope="props" slot="item">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <ws-avatar
                  :id="props.option.guid"
                  :name="`${ props.option.first.display } ${props.option.last.display}`"
                  sizeType="Small"
                  :size="48"
                />
              </figure>
            </div>
            <div class="media-content">
              <span v-if="props.option.last.display && props.option.first.display">
                <strong>{{ props.option.last.display }} {{ props.option.first.display }} {{ props.option.middle.display }}</strong> <br>
                <span class="has-text-primary">{{ props.option.email }}</span><br>
                <span class="has-text-primary">{{ getPhoneNumbers(props.option, 'profile.contacts.communication.phone') }}</span>
              </span>
            </div>
          </div>
        </template>
        <template slot="empty">{{$t('Пользователь не найден')}}</template>
      </ws-refbook-field>
    </b-field>
  </div>
</template>

<script>
import { getPhoneNumbers } from '@/utils/getPhoneNumber'
import expertTypesEnum from '../../demo-exams/data/expertTypesEnum'

export default {
  name: 'ws-users-search',
  props: {
    change: {
      type: Function,
      default: () => {}
    },
    expertSearch: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (expert) {
      this.change(expert, expertTypesEnum.user)
    },
    formatUserFullName (user) {
      let fullName = null
      if (user) {
        fullName = `${user.last.display} ${user.first.display} ${user.middle.display}`
      }
      user.fullName = fullName
      return fullName
    },
    getPhoneNumbers
  }
}
</script>
